import type { ValidationError } from './types'
import type { Datenverarbeitung } from '@/types/studyTypes'

export function validateDatenverarbeitung(d: Datenverarbeitung): ValidationError[] {
  const errors: ValidationError[] = []

  // KI present means object is set
  if (d.verarbeitungMitKi) {
    if (!d.verarbeitungMitKi.name?.trim())
      errors.push({ field: 'verarbeitungMitKi.name', message: 'KI-Name ist ein Pflichtfeld.' })
    if (!d.verarbeitungMitKi.ort?.length)
      errors.push({
        field: 'verarbeitungMitKi.ort',
        message: 'Bitte Ort der KI-Verarbeitung angeben.',
      })
  }

  // DiGA present means object is set
  if (d.diga) {
    if (!d.diga.name?.trim())
      errors.push({ field: 'diga.name', message: 'DiGA-Name ist ein Pflichtfeld.' })
  }

  // Bildgebende Verfahren present means object is set
  if (d.bildgebendeVerfahren) {
    if (!d.bildgebendeVerfahren.speicherOrt)
      errors.push({
        field: 'bildgebendeVerfahren.speicherOrt',
        message: 'Bitte Speicherort angeben.',
      })
  }

  if (
    d.publikationPersonenbezogenerDaten &&
    !d.publikationPersonenbezogenerDatenBeschreibung?.trim()
  )
    errors.push({
      field: 'publikationPersonenbezogenerDatenBeschreibung',
      message: 'Beschreibung der Publikation ist erforderlich.',
    })

  if (!d.datenfluss?.trim())
    errors.push({ field: 'datenfluss', message: 'Datenfluss ist ein Pflichtfeld.' })

  return errors
}
